// src/components/HomePage.tsx

import { motion } from "framer-motion";

import { AiOutlineArrowRight } from "react-icons/ai";

import machine from "../assets/home.png";

import "../styles/homepage.css";

const HomePage = () => {

  return (

    <section
      id="homepage"
      className="homepage"
    >

      {/* =========================
          HERO SECTION
      ========================= */}

      <div className="home-hero">

        {/* =========================
            LEFT
        ========================= */}

        <motion.div
          className="home-left"
          initial={{
            opacity:0,
            x:-40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.8
          }}
          viewport={{
            once:true
          }}
        >



          

          {/* TAG */}

          <span className="home-tag">
            SMART FITNESS NUTRITION
          </span>

          {/* TITLE */}

          <h1>
            Protein,
            <span> Ready </span>
            When You Are
          </h1>

          {/* DESCRIPTION */}

          <p>

            Walk into the gym with just your
            keys and phone. Dagda delivers
            fresh protein and recovery drinks
            instantly through smart vending
            technology built for modern fitness.

          </p>

          {/* =========================
              POINTS
          ========================= */}

          <div className="home-points">

            <div className="dagda-point">

              <div className="dagda-arrow">

                <AiOutlineArrowRight size={18} />

              </div>

              <p>
                Fresh shakes from trusted
                performance nutrition brands.
              </p>

            </div>

            <div className="dagda-point">

              <div className="dagda-arrow">

                <AiOutlineArrowRight size={18} />

              </div>

              <p>
                No tubs, no scoops,
                no shaker bottles.
              </p>

            </div>

            <div className="dagda-point">

              <div className="dagda-arrow">

                <AiOutlineArrowRight size={18} />

              </div>

              <p>
                Smart vending systems inside
                gyms, offices and wellness spaces.
              </p>

            </div>

          </div>

        </motion.div>

        {/* =========================
            RIGHT
        ========================= */}

        <motion.div
          className="home-right"
          initial={{
            opacity:0,
            x:40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.8
          }}
          viewport={{
            once:true
          }}
        >

          <div className="home-image-wrapper">

            <div className="home-circle"></div>

            <div className="small-circle one"></div>

            <div className="small-circle two"></div>

            <img
              src={machine}
              alt="Dagda Machine"
              className="home-machine"
            />

          </div>

        </motion.div>

      </div>

    </section>

  );
};

export default HomePage;